import React, { useState } from 'react';
import { Button, Form, Input, Modal, Tabs, Tooltip } from 'antd';
import { routerRedux } from 'dva/router';
import { NEW_TEST_CASE } from '../../../../constants';
import { NEWTESTCASE_DISNEY, NEWTESTCASE_ESPN, NEWTESTCASE_HULU, NEWTESTCASE_MODAL } from '../../../../testUtils';
import { CenteredDiv, LogoBtn, PaddedButton } from './styles';
import huluLogo from '../../../../../src/assets/Hulu.svg';
import dPlusLogo from '../../../../assets/DisneyPlus.svg';
import espnLogo from '../../../../../src/assets/Espn.svg';
import { DISNEY_PLUS_PUBLISHER, ESPN_PUBLISHER, HULU_PUBLISHER } from '../../constants';
import { FORM_HULU_ID_RULE, FORM_NOT_EMPTY_RULE, FORM_UUID_RULE } from '../../../../utils';
import { InfoCircleOutlined } from '@ant-design/icons';

const MODAL_TITLE = 'Link New Account';

const LAYOUT_STYLES = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const TAIL_STYLES = {
  wrapperCol: { offset: 8, span: 16 },
};

const AddAccount = ({ dispatch, open, setModalOpen }) => {
  const [accountProfileForm] = Form.useForm();
  const [userIdForm] = Form.useForm();
  const [swidForm] = Form.useForm();
  const [selectedPublisher, setSelectedPublisher] = useState('');

  const swidFormLayout = () => {
    return (
      <Form {...LAYOUT_STYLES} form={swidForm} onFinish={onSubmitSwid}>
        <Form.Item
          label="SWID"
          name="swid"
          rules={[{ required: true, message: 'Please input SWID' }, FORM_NOT_EMPTY_RULE]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={
            <span>
              Nickname&nbsp;
              <Tooltip title="Customize Profile Nickname: Links to your Profile, not the Account">
                <InfoCircleOutlined />
              </Tooltip>
            </span>
          }
          name="nickname"
          rules={[{ required: true, message: 'Please input Nickname' }, FORM_NOT_EMPTY_RULE]}
        >
          <Input />
        </Form.Item>{' '}
        <Form.Item {...TAIL_STYLES}>
          <Button onClick={backBtnClick}>Back</Button>
          <PaddedButton type="primary" htmlType="submit">
            Submit
          </PaddedButton>
        </Form.Item>
      </Form>
    );
  };

  const accountProfileFormLayout = () => {
    return (
      <Form {...LAYOUT_STYLES} form={accountProfileForm} onFinish={onSubmitAccountId}>
        <Form.Item
          label="Account Id"
          name="accountId"
          rules={[{ required: true, message: 'Please input Account Id' }, FORM_UUID_RULE]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Profile Id"
          name="profileId"
          rules={[{ required: true, message: 'Please input Profile Id' }, FORM_UUID_RULE]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={
            <span>
              Nickname&nbsp;
              <Tooltip title="Customize Profile Nickname: Links to your Profile, not the Account">
                <InfoCircleOutlined />
              </Tooltip>
            </span>
          }
          name="nickname"
          rules={[{ required: true, message: 'Please input Nickname' }, FORM_NOT_EMPTY_RULE]}
        >
          <Input />
        </Form.Item>{' '}
        <Form.Item {...TAIL_STYLES}>
          <Button onClick={backBtnClick}>Back</Button>
          <PaddedButton type="primary" htmlType="submit">
            Submit
          </PaddedButton>
        </Form.Item>
      </Form>
    );
  };

  const formGroup = [
    {
      name: 'Account/Profile',
      form: accountProfileFormLayout,
    },
    {
      name: 'SWID',
      form: swidFormLayout,
    },
  ];
  const onCancel = () => {
    dispatch(routerRedux.push('/' + NEW_TEST_CASE));
    setModalOpen(false);
    setSelectedPublisher('');
    accountProfileForm.resetFields();
    userIdForm.resetFields();
    swidForm.resetFields();
  };

  const onSubmitHulu = ({ userid }) => {
    onSubmitAccountId({ accountId: userid, profileId: null, nickname: null });
  };

  const onSubmitAccountId = ({ accountId, profileId, nickname }) => {
    const publisher = selectedPublisher;
    if (dispatch({ type: 'newTestCase/addAccountId', payload: accountId, profileId, nickname, publisher })) {
      onCancel();
    }
  };

  const onSubmitSwid = ({ swid, nickname }) => {
    if (dispatch({ type: 'newTestCase/addEspnSwidAccount', payload: swid, nickname })) {
      onCancel();
    }
  };

  const backBtnClick = () => {
    setSelectedPublisher('');
  };

  const renderModalContent = (publisher) => {
    switch (publisher) {
      case DISNEY_PLUS_PUBLISHER:
        return accountProfileFormLayout();
      case HULU_PUBLISHER:
        return (
          <Form {...LAYOUT_STYLES} form={userIdForm} onFinish={onSubmitHulu}>
            <Form.Item
              label="User Id"
              name="userid"
              rules={[{ required: true, message: 'Please input User Id' }, FORM_HULU_ID_RULE]}
            >
              <Input />
            </Form.Item>
            <Form.Item {...TAIL_STYLES}>
              <PaddedButton onClick={backBtnClick}>Back</PaddedButton>
              <PaddedButton type="primary" htmlType="submit">
                Submit
              </PaddedButton>
            </Form.Item>
          </Form>
        );
      case ESPN_PUBLISHER:
        return (
          <Tabs
            defaultActiveKey="1"
            size={'medium'}
            style={{ marginBottom: 32 }}
            items={formGroup.map((item, id) => {
              return {
                label: item.name,
                key: id,
                children: item.form(),
              };
            })}
          />
        );
      default:
        return (
          <CenteredDiv>
            <LogoBtn
              onClick={showDPlusForm}
              src={dPlusLogo}
              alt={'Add Disney Plus Account'}
              data-testid={NEWTESTCASE_DISNEY}
            />
            <LogoBtn onClick={showHuluForm} src={huluLogo} alt={'Add Hulu Account'} data-testid={NEWTESTCASE_HULU} />
            <LogoBtn onClick={showEspnForm} src={espnLogo} alt={'Add ESPN Account'} data-testid={NEWTESTCASE_ESPN} />
          </CenteredDiv>
        );
    }
  };

  const showDPlusForm = () => {
    setSelectedPublisher(DISNEY_PLUS_PUBLISHER);
  };

  const showHuluForm = () => {
    setSelectedPublisher(HULU_PUBLISHER);
  };

  const showEspnForm = () => {
    setSelectedPublisher(ESPN_PUBLISHER);
  };

  return (
    <Modal title={MODAL_TITLE} open={open} onCancel={onCancel} footer={null}>
      <div data-testid={NEWTESTCASE_MODAL}>{renderModalContent(selectedPublisher)}</div>
    </Modal>
  );
};

export default AddAccount;
